import { CompoundFilterItemsProps } from './CompoundFilterItems.types';
import { CompoundFilterItem } from './components';
import { useCompoundFilterContext } from '../../hooks';
import { Button } from '../../../buttons/Button';
import { RenderWhen } from '../../../RenderWhen';
import { resolveCompoundFilterStateModifiers } from '../../helpers';
import { Eraser } from '../../../icons';

export const CompoundFilterItems = ({ className }: CompoundFilterItemsProps) => {
  const { state, dispatch } = useCompoundFilterContext();
  return (
    <div className="flex gap-2">
      {state.map((item, itemIndex) => {
        const { isActive, isVisible } = resolveCompoundFilterStateModifiers(item.stateModifiers);

        return (
          <RenderWhen key={item.id} condition={isVisible}>
            <CompoundFilterItem
              options={item.options}
              className={className}
              label={item.label}
              isActive={isActive}
              onClick={() => {
                dispatch({
                  type: 'TOGGLE_ITEM',
                  payload: itemIndex,
                });
              }}
            />
          </RenderWhen>
        );
      })}
      <Button
        variant="transparent"
        className="flex !h-8 !w-8 items-center justify-center rounded-md bg-secondary-400 px-2 shadow-primary-outset transition-colors hover:bg-bg-secondary active:bg-secondary-700 active:shadow-primary-inset"
        onClick={() => {
          dispatch({
            type: 'CLEAR_ALL',
          });
        }}
      >
        <Eraser
          role="img"
          aria-label="Clear All"
          size="1.2rem"
          className="cursor-pointer stroke-primary-400"
        >
          <title>Clear All</title>
        </Eraser>
      </Button>
    </div>
  );
};
